import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import useThrottledCallback from 'hooks/throttledCallback';
import styles from './PlaybackButton.module.scss';

interface PlaybackButtonProps {
  focusId?: string | number | null;
  onSelect?: () => void;
  className?: string | null;
  ttsText?: string | null;
  render: (hasFocus: boolean) => React.ReactNode;
}

const PlaybackButton = ({
  onSelect = () => {},
  focusId = null,
  className = null,
  ttsText = null,
  render,
}: PlaybackButtonProps) => {
  const selectFunc = useThrottledCallback<() => void>(onSelect, 200);

  return (
    <Selectable
      focusId={focusId}
      onSelect={selectFunc}
      className={className}
      ttsText={ttsText ?? undefined}
      render={({ hasFocus }: { hasFocus: boolean }) => (
        <button
          type="button"
          data-testid="playback-button"
          onClick={onSelect}
          className={classNames(
            'bg-transparent',
            'd-flex',
            'justify-content-center',
            'align-items-center',
            styles.buttonWrapper,
          )}
        >
          {render(hasFocus)}
        </button>
      )}
    />
  );
};

export default React.memo(PlaybackButton);
